import classNames from 'classnames';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import Slider from 'components/Form/Fields/Slider/Slider';
import TextField from 'components/Form/Fields/Text/TextField';
import { bindFormControl } from 'components/Form/FormControl/FormControl';
import SelectField from 'components/Form/Fields/Select/SelectField';
import Spinner from 'components/Spinner/Spinner';
import TagsSelect from 'components/TagsSelect/TagsSelect';
import Controls from './Controls';
import TaskInfo from './TaskInfo';

import TaskForm, {
  OptionsLimits,
} from 'stores/Forms/TasksForms/TaskExtraClassifierForm';
import { TaskType } from 'stores/Recognition/types';

import style from './TaskForm.module.scss';

@observer
class TaskExtraClassifierForm extends Component<{
  type: TaskType.TRAIN_EXTRA_CLASSIFIER_TF_EFFICIENT_NET_B4;
}> {
  form: TaskForm = new TaskForm(this.props.type);
  formControl = bindFormControl(this.form);

  onSubmit = async event => {
    event.preventDefault();
    await this.form.onCreate();
  };

  async componentDidMount() {
    await this.form.init();
  }

  render() {
    const FormControl = this.formControl;

    return (
      <form className={style.task__form} onSubmit={this.onSubmit}>
        {this.form.loading && <Spinner contain />}

        <TaskInfo info={this.props.type} />

        <div className={style.form__body}>
          <FormControl
            name="previousTrainTaskId"
            className={classNames(
              style.control,
              style.control__option,
              style.control__wide,
            )}
            render={props => (
              <SelectField {...props} options={this.form.tasksOptions} />
            )}
          />

          <TagsSelect
            title="title.dataset.required"
            tags={this.form.datasetTags}
            selectedTags={this.form.selectedDatasets}
            onSubmit={this.form.setDatasets}
            onRemoveTag={this.form.removeDataset}
          />

          <FormControl
            name="description"
            className={classNames(style.control, style.control__description)}
            render={props => <TextField {...props} />}
          />

          <p className={style.title}>
            <FormattedMessage id="title.options" />
          </p>

          <div className={style.form__options}>
            <FormControl
              name="numEpochStage1"
              className={classNames(style.control, style.control__option)}
              render={props => (
                <Slider
                  {...props}
                  min={OptionsLimits.numEpochStageMin}
                  max={OptionsLimits.numEpochStageMax}
                  label="task.form.label.epochStage1"
                />
              )}
            />

            <FormControl
              name="numEpochStage2"
              className={classNames(style.control, style.control__option)}
              render={props => (
                <Slider
                  {...props}
                  min={OptionsLimits.numEpochStageMin}
                  max={OptionsLimits.numEpochStageMax}
                  label="task.form.label.epochStage2"
                />
              )}
            />
          </div>
        </div>

        <Controls
          disabled={
            !this.form.isFormValid || !this.form.selectedDatasets.length
          }
        />
      </form>
    );
  }
}

export default TaskExtraClassifierForm;
